/* eslint-disable */
import { StyleSheet } from 'react-native'
import { ApplicationStyles, Metrics } from '../../Themes/'
import { isIPhoneX } from '../../Lib/utils'

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container: {
    flex: 1
  },
  checkbox : {
    backgroundColor: `#FFFFFF`
  },
  
  footerButton: {
    height: isIPhoneX() ? 76 : 64,
    paddingBottom: 14,
  },
  term : {
    flexDirection: `row`, alignItems: `center` ,justifyContent: `center`
  }
  
})
